export default "__VITE_ASSET__BtkbJ_HU__"